import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      // Small delay to avoid layout shift on initial load
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookie-consent", "rejected");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[9999] animate-fade-in">
      <div className="bg-[#0C141F] text-white p-6 rounded-2xl shadow-2xl border border-white/10">
        <h3 className="font-medium text-lg mb-2">🍪 Cookies y privacidad</h3>
        <p className="text-sm text-white/70 mb-4 leading-relaxed">
          Utilizamos cookies propias y de terceros para mejorar tu experiencia, 
          analizar el tráfico y personalizar contenido. Puedes aceptar todas las 
          cookies o configurar tus preferencias.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={handleAccept}
            className="flex-1 bg-[#4A7CFF] hover:bg-[#3A6CEF] text-white font-medium py-2.5 px-4 rounded-lg transition-colors"
          >
            Aceptar todas
          </button>
          <button
            onClick={handleReject}
            className="flex-1 bg-white/10 hover:bg-white/20 text-white font-medium py-2.5 px-4 rounded-lg transition-colors"
          >
            Solo esenciales
          </button>
        </div>
        <p className="text-xs text-white/50 mt-3">
          Más información en nuestra{" "}
          <Link to="/politica-cookies" className="underline hover:text-white/70">
            Política de cookies
          </Link>
        </p>
      </div>
    </div>
  );
};

export default CookieConsent;
